import { render } from "./GlobalComponent.vue?vue&type=template&id=8c5666ce"
import script from "./GlobalComponent.vue?vue&type=script&lang=js"
export * from "./GlobalComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/spom.vh/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__